import { render, staticRenderFns } from "./TravelCarAdd.vue?vue&type=template&id=398385a4&"
import script from "./TravelCarAdd.vue?vue&type=script&lang=js&"
export * from "./TravelCarAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports